module.exports = "/_next/static/images/58f7c4e2e333426ee9cc242a12fe1133-nubank-outdoor-xs@2x.jpg.webp";